import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "./lib/LangContext";
import LandingPage from "./pages/LandingPage";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Toaster
            theme="dark"
            position="bottom-right"
            duration={3000}
            toastOptions={{
              style: {
                background: "#000",
                color: "#fff",
                border: "1px solid #FFD60A",
                borderRadius: 0,
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
